import React from "react";
import { Flex, Text, Pen, TouchableOpacity } from "@atoms";
import { useToggle } from "@hooks";
import { EditSubGroup } from "../Modals/EditSubGroup";
// import styled from "@emotion/styled";

// == Types ================================================================

interface IProps {
  name: string | null;
}

// == Constants ============================================================

GroupSubHeader.defaultProps = {};

// == Functions ============================================================

const groupNameEditChecker = (id: string) => {
  return id === "__noGroup__" || id === "__pending__";
};

// == Component ============================================================

export default function GroupSubHeader({ id, name }: IProps) {
  const [isEditSubGroupOpen, setIsEditSubGroupOpen] = useToggle(false);

  return (
    <>
      <Flex bg="lightBg" my={3} padding={3}>
        <Text paddingRight={[1, 2, 3]}>{name}</Text>
        {groupNameEditChecker(id) || (
          <TouchableOpacity onTouch={() => setIsEditSubGroupOpen(true)}>
            <Pen color="#666" size="xs" />
          </TouchableOpacity>
        )}
      </Flex>
      {isEditSubGroupOpen && (
        <EditSubGroup
          id={id}
          isEditSubGroupOpen={isEditSubGroupOpen}
          name={name}
          setIsEditSubGroupOpen={setIsEditSubGroupOpen}
        />
      )}
    </>
  );
}

// == Styles ===============================================================
